<style lang="scss" scoped>
.circle {
  border-radius: 100%;
  background-color: $danger;
  transition: background-color 0.3s linear;
  height: 15px;
  width: 15px;
  flex-shrink: 0;

  &--online {
    background-color: $green;
  }
}
</style>

<template>
  <div class="circle" :class="{ 'circle--online': isOnline }"></div>
</template>
<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  computed: {
    isOnline() {
      return this.$store.getters["online/profileOnline"](this.id);
    }
  }
};
</script>
